// import React from "react";
// import Stylecontent from "./blogs.module.css";
// import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import { Link, Routes } from "react-router-dom";
// import { delay, motion } from "framer-motion";
// import blogs from "../data";
// import Cover from "../cover";
// import { IoIosArrowDown } from "react-icons/io";
// import Homecover from "../../Ui/sliderImg4.jpeg";
// import Homecover2 from "../../Ui/sliderImg5.jpg";
// import Homecover3 from "../../Ui/sliderImg3.jpg";

// const Blogs = () => {
//   const variant = {
//     visible: { scale: 1 },
//     hidden: { scale: 0 },
//   };

//   return (
//     <>
//       <Cover
//         images={[Homecover, Homecover2, Homecover3]}
//         heading="Welcome to our Blogs Page"
//         subHeading="Read Our Latest Blogs"
//       />

//       {/* <div id="doctors">
//         <motion.div
//           className={Stylecontent.toptext}
//           initial={{ y: -100 }}
//           animate={{ y: [200, 0] }}
//           transition={{ duration: "1", delay: "1" }}
//           whileInView="visible"
//         >
//           <h1>Meet Our Doctors Team</h1>
//           <h3>To Find Best Doctors</h3>
//           <p>
//             Great doctor if you need your family member to get immediate
//             assistance, emergency treatment or a simple consultation.
//           </p>
//         </motion.div>

//         <div className={Stylecontent.container}>
//           {blg.map((i) => (
//             <motion.div
//               className={Stylecontent.cards}
//               variants={variant}
//               initial={{ y: -100 }}
//               animate={{ y: [400, 0] }}
//               transition={{ duration: "1" }}
//               whileInView="visible"
//               whileHover={{ scale: 1.1 }}
//             >
//               <Card sx={{ maxWidth: 450, margin: 3 }}>
//                 <div className={Stylecontent.media}>
//                   <CardMedia
//                     sx={{ height: 200 }}
//                     image={i.image}
//                     title="Doctors"
//                     style={{ objectFit: "cover", marginBottom: "0" }}
//                   />

//                 </div>

//                 <motion.div
//                   whileHover={{ background: "lightBlue", color: "black" }}
//                 >
//                   <CardContent sx={{ padding: "16px" }}>
//                     <Typography gutterBottom variant="h5" component="div">
//                       {i.name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {i.degree}
//                     </Typography>
//                   </CardContent>

//                   <CardActions>
//                     <div className={Stylecontent.btns}>
//                       <Button variant="outlined" href="#outlined-buttons">
//                         Share
//                       </Button>
//                     </div>
//                     <div>
//                       <Link
//                         to={`/doctor/${i.id}`}
//                         style={{ textDecoration: "none" }}
//                       >
//                         <Button variant="outlined" href="#outlined-buttons">
//                           View more
//                         </Button>
//                       </Link>
//                     </div>
//                   </CardActions>
//                 </motion.div>
//               </Card>
//             </motion.div>
//           ))}
//         </div>
//       </div> */}

//       <div className={Stylecontent.maincontainer}>
//         <motion.div
//           className={Stylecontent.toptext}
//           initial={{ y: -100 }}
//           animate={{ y: [200, 0] }}
//           transition={{ duration: "1", delay: "1" }}
//           whileInView="visible"
//         >
//           <h1>Blogs</h1>
//           <p>
//             Our blogs cover a wide range of topics, including medical
//             advancements, health tips, and wellness advice. Stay informed and
//             empowered with our informative articles.
//           </p>
//         </motion.div>

//         <motion.div
//           className={Stylecontent.arrowdown}
//           animate={{ y: [0, 10, 0] }}
//           transition={{ repeat: Infinity, duration: 1 }}
//         >
//           <IoIosArrowDown size={40} color="#333" />
//         </motion.div>

//         <div className={Stylecontent.container}>
//           {blogs.map((i) => (
//             <motion.div
//               className={Stylecontent.cards}
//               initial={{ opacity: 0, scale: 0.8, y: 50 }}
//               whileInView={{ opacity: 1, scale: 1, y: 0 }}
//               whileHover={{ scale: 1.05 }}
//               transition={{
//                 duration: 0.8,
//                 ease: "easeOut",
//                 type: "spring",

//                 delay: i.id * 0.1, // slight stagger if looping
//               }}
//             >
//               <Card sx={{ maxWidth: 350, borderRadius: 3, boxShadow: 4 }}>
//                 <div className={Stylecontent.media}>
//                   <CardMedia
//                     sx={{ height: 200 }}
//                     image={i.image}
//                     title="Doctors"
//                     style={{ objectFit: "cover", marginBottom: "0" }}
//                   />
//                 </div>

//                 <div className={Stylecontent.cardtext}>
//                   <CardContent>
//                     <Typography gutterBottom variant="h5" component="div">
//                       {i.name}
//                     </Typography>

//                     <Typography variant="body2" color="text.secondary" mt={1}>
//                       {i.desp.slice(0, 90)}...
//                     </Typography>
//                   </CardContent>
//                   <CardActions>
//                     <Button variant="outlined" href="#outlined-buttons">
//                       View More
//                     </Button>
//                   </CardActions>
//                 </div>
//               </Card>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Blogs;

import React, { useState } from "react";
import Stylecontent from "./blogs.module.css";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import blogs from "../data";
import Cover from "../cover";
import { IoIosArrowDown } from "react-icons/io";
import {
  AiOutlineHeart,
  AiOutlineEye,
  AiOutlineClockCircle,
} from "react-icons/ai";
import BlogCover from "../../Ui/blogCover.jpg";
import BlogCover1 from "../../Ui/blogCover1.jpg";
import BlogCover2 from "../../Ui/blogCover2.jpeg";

const Blogs = () => {
  const [likes, setLikes] = useState(Array(blogs.length).fill(0));

  const handleLike = (index) => {
    const updated = [...likes];
    updated[index]++;
    setLikes(updated);
  };

  return (
    <>
      <Cover
        images={[BlogCover, BlogCover1, BlogCover2]}
        heading="Welcome to our Blogs Page"
        subHeading="Read Our Latest Blogs"
      />

      <div className={Stylecontent.maincontainer}>
        <motion.div
          className={Stylecontent.toptext}
          initial={{ y: -100 }}
          animate={{ y: [200, 0] }}
          transition={{ duration: "1", delay: "1" }}
          whileInView="visible"
        >
          <h1>Blogs</h1>
          <p>
            Our blogs cover a wide range of topics, including medical
            advancements, health tips, and wellness advice.
          </p>
        </motion.div>

        <motion.div
          className={Stylecontent.arrowdown}
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1 }}
        >
          <IoIosArrowDown size={40} color="#333" />
        </motion.div>

        <div className={Stylecontent.container}>
          {blogs.map((i, index) => (
            <motion.div
              key={i.id}
              className={Stylecontent.cards}
              initial={{ opacity: 0, scale: 0.8, y: 50 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              whileHover={{ scale: 1.05 }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
                type: "spring",
                delay: i.id * 0.1,
              }}
            >
              <Card sx={{ maxWidth: 350, borderRadius: 3, boxShadow: 4 }}>
                <div className={Stylecontent.media}>
                  <CardMedia
                    sx={{ height: 200 }}
                    image={i.image}
                    title={i.name}
                    style={{ objectFit: "cover" }}
                  />
                </div>

                <div className={Stylecontent.cardtext}>
                  <CardContent>
                    <Typography gutterBottom variant="h6">
                      {i.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mt={1}>
                      {i.desp.slice(0, 50)}...
                    </Typography>
                  </CardContent>

                  <CardActions className={Stylecontent.cardActions}>
                    {/* Insight row */}
                    <div className={Stylecontent.insightRow}>
                      <motion.div
                        whileTap={{ scale: 0.9 }}
                        onClick={() => handleLike(index)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <AiOutlineHeart size={20} color="#e63946" />
                        <span style={{ marginLeft: "5px", fontSize: "0.9rem" }}>
                          {likes[index]}
                        </span>
                      </motion.div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AiOutlineEye size={20} color="#555" />
                        <span style={{ marginLeft: "5px", fontSize: "0.9rem" }}>
                          {i.views}
                        </span>
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AiOutlineClockCircle size={18} color="#777" />
                        <span style={{ marginLeft: "5px", fontSize: "0.9rem" }}>
                          {i.readTime}
                        </span>
                      </div>
                    </div>
                    <Link to={`/blogs/${i.id}`}>
                      <Button variant="outlined" fullWidth>
                        View More
                      </Button>
                    </Link>
                  </CardActions>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Blogs;
